export function formatVariantLabel(variant) {
  if (!variant) return ''
  const name = variant.name || variant.id || ''
  const pct = Number(variant.trafficPercent ?? variant.traffic_percent ?? 0)
  if (!Number.isFinite(pct)) return name
  return pct > 0 ? `${name} (${pct}%)` : name
}

export const USER_PARAM_TYPES = [
  { key: 'adtag', label: 'Ad tag' },
  { key: 'level', label: 'Level' },
  { key: 'lifetime', label: 'Lifetime' },
  { key: 'payable', label: 'Payable' },
  { key: 'rv_day', label: 'RV day' },
  { key: 'rv_total', label: 'RV total' },
  { key: 'campaign', label: 'Campaign' },
  { key: 'payer_segmentation', label: 'Payer segmentation' },
  { key: 'session_time', label: 'Session time' },
]
